import { useEffect } from 'react'

export const useAnimation = () => {
    useEffect(() => {
        const elements = [
            ...document.querySelectorAll('.maplexxon-animation-translate-start'),
            ...document.querySelectorAll('.maplexxon-animation-scale-start')
        ]
        const options = {
            root: null,
            threshold: 0.2
        }

        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("maplexxon-animation-end")
                    entry.target.classList.remove("maplexxon-animation-translate-start", "maplexxon-animation-scale-start")
                    observer.unobserve(entry.target);
                } else {
                    return;
                }
            });
        }, options);

        elements.forEach(element => observer.observe(element))
        return () => observer.disconnect();
    }, []);
}